import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import area from '../common';
import options from '../cityOfProvinces';
import config from '../../../api/params.config';
import DateDropdown from '@/components/DateDropdown.vue';

import {Select, Option, Cascader, DatePicker} from 'element-ui';
import { WeChatUserInfo } from './WeChatUserInfo';
import moment from 'moment';
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(DatePicker);
// @ts-ignore
@Component({
    components: {
        DateDropdown,
    },
})
export default class NewResume extends Vue {
    private $api: any;
    private $reg: any;
    private $cookie: any;
    private isEdit: boolean = false;       // 编辑状态
    private inResumeList: boolean = false; // 在录用简历中
    private resumeId: string = '';
    private model: any = {ChannelType: 1, username: '', sex: '',  sexId: '', nativePlace: '', nativePlaceCode: '', familyPlace: '', familyPlaceCode: '', telphone: '', email: '', wechatNumber: '', university: '', major: '', education: '', educationId: '', graduationTime: '', InforSource: '', InforSourceId: '', InforSourceText: '', jobOne: '', jobTwo: '', jobPlace: '', jobPlaceCode: '', selfEvaluation: '', radioOne: '', radioOneId: '', radioTwo: '', radioTwoId: '', fileList: [], fileIds: []};
    private file: any = {fileType: '*', fileLength: 9, fileSize: 5 * 1024};
    private IsArea: boolean = false;
    private isPopup: boolean = false;
    private isWhichOne: string = '';
    private info: any = {showInfoSorceText: false, InfoSorcePlaceholder: '', isMobil: true, isDisabled: false, areaList: [], optionsList: []};
    private message: any = {nameError: '', telphoneError: '', emailError: '', wechatNumberError: '', universityError: '', majorError: '', selfEvaluationError: '', InforSourceTextError: ''};
    private step: string = '1';
    private columnsValue: any = {columns: [], IntentionalPost: [], HighestEducation: [], SchoolRecruitSource: [], options: [{ Id : 0, text: '男'}, {Id: 1, text : '女'}]};
    private user: WeChatUserInfo = new WeChatUserInfo();
    private WeChatloginUrl: string = '';
    private WeChatloginShow: boolean = false;

    private async created() {
        const redirctUri = location.origin + '?wechatlogin=new-resume'; // 微信登录回调地址
        // const redirctUri = 'http://ehr-wechat-vue.lunz.cn' + '?wechatlogin=new-resume'; 
        const APPID = 'wx8bd163152e905511'; // 开放平台应用ID
        this.WeChatloginUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${encodeURI(redirctUri)}&response_type=code&scope=snsapi_login&state=ehrpclogin#wechat_redirect`;
        console.log(this.WeChatloginUrl);
        // 判断是PC端还是手机端
        function checkMobile() {
            // tslint:disable-next-line:variable-name
            const pda_user_agent_list = ['2.0 MMP', '240320', 'AvantGo', 'BlackBerry', 'Blazer',
                    'Cellphone', 'Danger', 'DoCoMo', 'Elaine/3.0', 'EudoraWeb', 'hiptop', 'IEMobile', 'KYOCERA/WX310K', 'LG/U990',
                    'MIDP-2.0', 'MMEF20', 'MOT-V', 'NetFront', 'Newt', 'Nintendo Wii', 'Nitro', 'Nokia',
                    'Opera Mini', 'Opera Mobi', 'Palm', 'Playstation Portable', 'portalmmm', 'Proxinet', 'ProxiNet',
                    'SHARP-TQ-GX10', 'Small', 'SonyEricsson', 'Symbian OS', 'SymbianOS', 'TS21i-10', 'UP.Browser', 'UP.Link',
                    'Windows CE', 'WinWAP', 'Android', 'iPhone', 'iPod', 'iPad', 'Windows Phone', 'HTC'];
            // tslint:disable-next-line:variable-name
            const pda_app_name_list = ['Microsoft Pocket Internet Explorer'];
            // tslint:disable-next-line:variable-name
            const user_agent = navigator.userAgent.toString();
            for (const a of pda_user_agent_list) {
                if (user_agent.indexOf(a) >= 0) {
                    return true;
                }
            }
            const appName = navigator.appName.toString();
            for (const b of pda_app_name_list) {
                if (user_agent.indexOf(b) >= 0) {
                    return true;
                }
            }
            return false;
        }
        if (checkMobile()) {
            // 移动端
            this.info.isMobil = true;
            this.info.areaList = area;
            // 使用微信公众平台登录
            this.loginWeChatMobile();
        } else {
            // pc端
            this.info.isMobil = false;
            this.info.optionsList = options.options;
            // 使用微信开放平台登录
            // this.user.unionid = 'oSlQCt6c3xU1WDvD22bDgTIO_plQ';
            
            this.loginWeChatPC();
        }
        
        // 如果没有认证参数，说明是第一次进入页面，不需要去获取数据源，等待微信登录认证后跳转
        if (!location.href.split('?')[1]) {
            return;
        }
        
        // 学历获取
        const HighestEducation = await this.$api.httpGet('WeChatInterface/RecruitmentSchoolWeChat/TypeList', { id: config.HighestEducationTypeId });
        if (HighestEducation.Success) {
            if (HighestEducation.Data) {
                for (const x of HighestEducation.Data) {
                    this.columnsValue.HighestEducation.push({ Id: x.Id, text: x.Value });
                }

            } else {    
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: HighestEducation.AllMessages,
            });
        }
        // 校招信息来源获取
        const SchoolRecruitSource = await this.$api.httpGet('WeChatInterface/RecruitmentSchoolWeChat/TypeList', { id: config.SchoolRecruitSourceId });
        if (SchoolRecruitSource.Success) {
            if (SchoolRecruitSource.Data) {
                for (const x of SchoolRecruitSource.Data) {
                    this.columnsValue.SchoolRecruitSource.push({Id: x.Id, text: x.Value});
                }
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: SchoolRecruitSource.AllMessages,
            });
        }
        // 意向岗位获取
        const IntentionalPostResult = await this.$api.httpGet('WeChatInterface/RecruitmentSchoolWeChat/GetPostList');
        if (IntentionalPostResult.Success) {
            if (IntentionalPostResult.Data) {
                for (const x of IntentionalPostResult.Data) {
                    this.columnsValue.IntentionalPost.push(x.RecruitPosition);
                }
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: IntentionalPostResult.AllMessages,
            });
        }

        // 检查当前状态是新增还是编辑
        if (this.user.unionid) {
            this.checkOperationState();
        }
    }

    // 3.4.10 投递简历使用微信登录
    /**
     * @description 微信公众平台登录(移动端)
     * @description 第一次进入页面：查询地址栏参数，没有unionid，发起微信授权认证，认证完成后通过回调第二次进入页面
     * @description 第二次进入页面：查询地址栏参数，存在unionid，则认证成功，并记录unionid
     */
    private loginWeChatMobile() {
        const query = new URLSearchParams(location.href.split('?')[1]);
        this.user.initWithURLSearchParams(query);
        if (this.user.openid && this.user.unionid) {
            console.log(this.user.nickname + ' 已登录');
        } else {
            const uri = location.origin + '?wechatlogin=new-resume';
            location.href = 'http://scrm.lunz.cn/OpenOAuth/getuserinfo?appId=wx70cfc5b45951c5c8&fromurl=' + encodeURI(uri);
        }
    }
    /**
     * @description 微信开放平台登录(PC端)
     * @description 第一次进入页面：查询地址栏参数，没有code，显示登陆二维码，认证完成后通过回调第二次进入页面
     * @description 第二次进入页面：查询地址栏参数，存在code，将code传给后台换取unionid，如果成功则记录unionid，如果不成功则弹出登陆二维码重新认证
     */
    private loginWeChatPC() {
        const query = new URLSearchParams(location.href.split('?')[1]);
        if (query.get('code')) {
            this.user.code = query.get('code');
            this.getUnionidByCode(); // code传给后台换取unionid
        } else {
            this.WeChatloginShow = true;
        }
    }
    /**
     * @description 根据code获取UnionID
     * @description 这里需要后台调用微信开放平台相关接口，将code通过微信接口交换为unionid，并传回前台
     */ 
    private async getUnionidByCode() {
        const result = await this.$api.httpGet('Recruitment/RecruitmentSchool/GetUnionidAndOpenid', { code: this.user.code });
        if (result.Success) {
            this.user.unionid = result.Data.unionid;
            this.user.openid = result.Data.openid;
            if (this.user.unionid) {
                // 认证通过，根据unionid获取用户简历状态，开始简历投递相关业务
                this.checkOperationState();
            } else {
                this.needLogin();
            }
        } else {
            // 这里除了后台接口出错以外，还有一种原因是code已经被解析过一次
            // code存在于查询参数中，第一次回调进入页面它被正确解析，但用户刷新页面或者故意拼接code参数时也会去后端认证，第二次解析code时已经失效，需要重新扫码
            this.needLogin();
        }
    }

    /** 
     * @description 如果解析失败，跳转回去登录
     */ 
    private needLogin() {
        // 这里实际上不会发生跳转，因为路由没有发生任何变化，只是把参数清空了, 所以手动把code清空并弹出二维码
        this.$router.push('/new-resume');
        this.user.code = '';
        this.WeChatloginShow = true;
    }

    /** @description 投递简历相关功能的入口函数
     *  @description 根据unionid判断当前简历状态，判断当前用户是需要新建简历还是编辑一个已存在的简历
     *  @var Add 查不到 (只有这个状态是投递新简历，其他都是编辑)
     *  @var NewResumeList 简历已投递，存在于新增简历库
     *  @var ResumeList 简历已投递，存在于录用简历库，而且只可以编辑基础信息
     *  @var TalentPoolList 简历已投递，存在于人才库
     */
    private async checkOperationState() {
        const result = await this.$api.httpGet(`WeChatInterface/RecruitmentSchoolWeChat/GetJudgeUseInsertOrUpdate`, { unionid: this.user.unionid });
        if (result.Success) {
            if (result.Data !== 'Add') {
                this.isEdit = true;
                this.getCampResume();
                if (result.Data === 'ResumeList') {
                    this.inResumeList = true; // 是录用简历，录用简历只可编辑基础信息
                }
            }
        }
    }

    /** @description 获取回显的简历信息 */ 
    private async getCampResume() {
        const result = await this.$api.httpGet(`WeChatInterface/RecruitmentSchoolWeChat/GetCampResumByOpenid`, { unionid: this.user.unionid });
        if (result.Success) {
            this.resumeId = result.Data.Id;
            this.model.username = result.Data.Name;
            this.model.sexId = result.Data.Sex;
            this.model.sex = this.columnsValue.options.find((op: any) => op.Id === this.model.sexId).text;
            this.model.nativePlaceCode = result.Data.NativePlace;
            this.model.nativePlace = result.Data.NativePlace;
            if (!this.info.isMobil) { this.model.nativePlace = [this.findPlace(result.Data.NativePlace), result.Data.NativePlace]; }
            this.model.familyPlaceCode = result.Data.FamilyHabitat;
            this.model.familyPlace = result.Data.FamilyHabitat;
            if (!this.info.isMobil) { this.model.familyPlace = [this.findPlace(result.Data.FamilyHabitat), result.Data.FamilyHabitat]; }
            this.model.telphone = result.Data.PhoneNumber;
            this.model.email = result.Data.Email;
            this.model.university = result.Data.SchoolName;
            this.model.major = result.Data.SchoolMajor;
            this.model.graduationTime = result.Data.GraduationTime;
            this.model.educationId = result.Data.EducateType;
            this.model.education = this.columnsValue.HighestEducation.find((op: any) => op.Id === this.model.educationId).text;
            this.model.InforSourceId = result.Data.ResumeSource;
            this.changeSource({Id: this.model.InforSourceId});
            this.model.InforSource = this.columnsValue.SchoolRecruitSource.find((op: any) => op.Id === this.model.InforSourceId).text;
            this.model.InforSourceText = result.Data.DetailSources;
            this.model.jobOne = result.Data.RecruitmentjobOne;
            this.model.jobTwo = result.Data.RecruitmentjobTwo;
            this.model.jobPlaceCode = result.Data.IntentionalWorkplace;
            this.model.jobPlace = result.Data.IntentionalWorkplace;
            if (!this.info.isMobil) { this.model.jobPlace = [this.findPlace(result.Data.IntentionalWorkplace), result.Data.IntentionalWorkplace]; }
            this.model.radioOneId = result.Data.AdjustJob;
            this.model.radioOne = this.model.radioOneId ? '1' : '2';
            this.model.radioTwoId = result.Data.AdjustPlace;
            this.model.radioTwo = this.model.radioTwoId ? '1' : '2';
            this.model.selfEvaluation = result.Data.SelfEvaluation;
            this.getFiles();
            console.log(this.model);
        }
    }

    // 获取附件列表
    private async getFiles() {
        const result = await this.$api.httpGet(`WeChatInterface/RecruitmentSchoolWeChat/GetCampEnclosure`, { Id: this.resumeId });
        if (result.Success) {
            this.model.fileList = [];
            this.model.fileIds = [];
            result.Data.forEach((file: any) => {
                // this.model.fileList.push({ url: 'http:' + file.Url });
                const fileItem: any = {
                    type: 'review',
                    name: file.Filename,
                };
                this.model.fileList.push({ file: fileItem, content: file.Url });
                this.model.fileIds.push(file.FileId);
            });
        }
    }

    // 删除附件
    private async delImg(index: any) {
        if (isNaN(index) || index >= this.model.fileList.length) {
            return false;
        }
        const tmp = [];
        for (let i = 0, len = this.model.fileList.length; i < len; i++) {
            if (this.model.fileList[i] !== this.model.fileList[index]) {
                tmp.push(this.model.fileList[i]);
            }
        }
        this.model.fileList = tmp;
        this.model.fileIds.splice(index, 1);
    }
    // 上传之前判断附件
    private async onRead(file: any) {
        if (this.model.fileList.length > this.file.fileLength) {
            this.$notify({
                message: '最多可添加10个',
                duration: 2000,
                background: 'rgb(255, 68, 68)',
              });
            return;
        } else if (file.file.type !== 'image/png' && file.file.type !== 'image/jpg' && file.file.type !== 'image/jpeg' && file.file.type !== 'image/bmp' && file.file.type !== 'application/msword' && file.file.type !== 'application/pdf') {
            this.$notify({
                message: '请上传附件类型为png,jpg,bmp,doc,pdf的文件',
                duration: 3000,
                background: 'rgb(255, 68, 68)',
            });
            return;
        } else if ((file.file.size / 1024).toFixed(1) > this.file.fileSize) {
            this.$notify({
                message: '附件最大为5M',
                duration: 3000,
                background: 'rgb(255, 68, 68)',
            });
            return;
        }
        const fileModel = file.file;
        const formData = new FormData();
        formData.append('files', fileModel, fileModel.name);
        const FileResult = await this.$api.httpPost('WeChatInterface/RecruitmentSchoolWeChat/AddEnclosureAliyun', formData);
        if (FileResult.Success) {
            if (FileResult.Data) {
                this.model.fileIds.push(FileResult.Data.Id );
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: FileResult.AllMessages,
            });
            return;
        }
        this.model.fileList.push(file);
    }

    // 底部弹出框初始化
    private async showPopup(item: number) {
        if (this.inResumeList) {
            return;
        }
        if (item === 1) {
            this.columnsValue.columns = this.columnsValue.options;
            this.isWhichOne = '1';
        } else if (item === 2) {
            this.columnsValue.columns = this.columnsValue.HighestEducation;
            this.isWhichOne = '2';
        } else if (item === 3) {
            this.columnsValue.columns = this.columnsValue.SchoolRecruitSource;
            this.isWhichOne = '3';
        } else if (item === 4) {
            this.columnsValue.columns = this.columnsValue.IntentionalPost;
            this.isWhichOne = '4';
        } else if (item === 5) {
            this.columnsValue.columns = this.columnsValue.IntentionalPost;
            this.isWhichOne = '5';
        }
        this.isPopup = !this.isPopup;
    }
    // 弹出框确定事件
    private async surePopup(val: any) {
        this.isPopup = false;
        if (this.isWhichOne === '1') {
            this.model.sex = val.text;
            this.model.sexId = val.Id;
        } else if (this.isWhichOne === '2') {
            this.model.education = val.text;
            this.model.educationId = val.Id;
        } else if (this.isWhichOne === '3') {
            this.model.InforSource = val.text;
            this.model.InforSourceId = val.Id;
            switch (this.model.InforSourceId) {
                // 其他
                case 'c2eb0000-5ea9-e0d5-776d-08d71fae6e33':
                this.info.showInfoSorceText = true;
                this.info.InfoSorcePlaceholder = '请注明您获取信息的来源';
                break;
                // "校园宣讲会"
                case 'c2eb0000-5ea9-e0d5-37b5-08d71fae015b':
                this.info.showInfoSorceText = true;
                this.info.InfoSorcePlaceholder = '您参加宣讲会的学校';
                break;
                // "校园双选会"
                case 'c2eb0000-5ea9-e0d5-beee-08d71fae0a43':
                this.info.showInfoSorceText = true;
                this.info.InfoSorcePlaceholder = '您参加双选会的学校';
                break;
                // "求职网站"
                case 'c2eb0000-5ea9-e0d5-cf0a-08d71fae0f3e':
                this.info.showInfoSorceText = true;
                this.info.InfoSorcePlaceholder = '请填写网站名称';
                break;
                // "学校就业公众号"
                case 'c2eb0000-5ea9-e0d5-e225-08d71fae140a':
                this.info.showInfoSorceText = true;
                this.info.InfoSorcePlaceholder = '请填写公众号名称';
                break;
                // 其他不弹出详细来源
                default: {
                this.info.showInfoSorceText = false;
                this.info.InfoSorcePlaceholder = '';
                break;
                }
            }
        } else if (this.isWhichOne === '4') {
            this.model.jobOne = val;
        } else if (this.isWhichOne === '5') {
            this.model.jobTwo = val;
        }
    }
    // 同一个城市控件不同地方使用初始化
    private async showArea(item: number) {
        if (this.inResumeList) {
            return;
        }
        if (item === 1) {
            this.isWhichOne = '1';
        } else if (item === 2) {
            this.isWhichOne = '2';
        } else if (item === 3) {
            this.isWhichOne = '3';
        }
        this.IsArea = !this.IsArea;
    }
    // 城市空间确定事件
    private async sureArea(val: any) {
        this.IsArea = false;
        if (this.isWhichOne === '1') {
            this.model.nativePlace = val[0].name + val[1].name;
            this.model.nativePlaceCode = val[1].name;
        } else if (this.isWhichOne === '2') {
            this.model.familyPlace = val[0].name + val[1].name;
            this.model.familyPlaceCode = val[1].name;
        } else if (this.isWhichOne === '3') {
            this.model.jobPlace = val[0].name + val[1].name;
            this.model.jobPlaceCode = val[1].name;
        }
    }
    // 验证手机格式和邮箱
    private async blur(val: any) {
        if (val === 'telphone') {
            if (!this.$reg.isPhone(this.model.telphone)) {
                this.message.telphoneError = '手机号格式不正确！';
            } else {
                this.message.telphoneError = '';
            }
        } else if (val === 'email') {
            if (!this.$reg.isEmail(this.model.email)) {
                this.message.emailError = '邮箱格式不正确！';
            } else {
                this.message.emailError = '';
            }
        }
    }

    // PC端选择下拉框性别
    private changeSex(e: any) {
        this.model.sexId = e.Id;
    }
    // PC端选择下拉框学历
    private changeEducation(e: any) {
        this.model.educationId = e.Id;
    }
    // PC端选择下拉框意向岗位1
    private changePostOne(e: any) {
        this.model.jobOne = e;
    }
    // PC端选择下拉框意向岗位2
    private changePostTwo(e: any) {
        this.model.jobTwo = e;
    }
    // PC端选择下拉框校招来源
    private changeSource(e: any) {
        this.model.InforSourceId = e.Id;
        switch (this.model.InforSourceId) {
            // 其他
            case 'c2eb0000-5ea9-e0d5-776d-08d71fae6e33':
            this.info.showInfoSorceText = true;
            this.info.InfoSorcePlaceholder = '请注明您获取信息的来源';
            break;
            // "校园宣讲会"
            case 'c2eb0000-5ea9-e0d5-37b5-08d71fae015b':
            this.info.showInfoSorceText = true;
            this.info.InfoSorcePlaceholder = '您参加宣讲会的学校';
            break;
            // "校园双选会"
            case 'c2eb0000-5ea9-e0d5-beee-08d71fae0a43':
            this.info.showInfoSorceText = true;
            this.info.InfoSorcePlaceholder = '您参加双选会的学校';
            break;
            // "求职网站"
            case 'c2eb0000-5ea9-e0d5-cf0a-08d71fae0f3e':
            this.info.showInfoSorceText = true;
            this.info.InfoSorcePlaceholder = '请填写网站名称';
            break;
            // "学校就业公众号"
            case 'c2eb0000-5ea9-e0d5-e225-08d71fae140a':
            this.info.showInfoSorceText = true;
            this.info.InfoSorcePlaceholder = '请填写公众号名称';
            break;
            // 其他不弹出详细来源
            default: {
            this.info.showInfoSorceText = false;
            this.info.InfoSorcePlaceholder = '';
            break;
            }
        }
    }
    // PC端选择籍贯
    private handleChangeNative(e: any) {
        console.log(e);
        this.model.nativePlaceCode = e[1];
        // console.log(this.model.nativePlace);
    }
    // PC端选择毕业时间
    private changeGraduationTime(e: any) {
        this.model.graduationTime = moment(e).format('YYYY-MM-DD');
    }
    // PC端选择家庭常驻地
    private handleChangeFamily(e: any) {
        this.model.familyPlaceCode = e[1];
    }
    // PC端选择意向工作地
    private handleChangejobPlace(e: any) {
        this.model.jobPlaceCode = e[1];
    }
    // 保存并下一步
    private async saveNext() {
        if (this.model.username !== '' && this.model.sexId !== '' && this.model.nativePlaceCode !== '' && this.model.familyPlaceCode !== '' && this.model.telphone !== '' && this.model.email !== '' && this.model.university !== '' && this.model.major !== '' && this.model.educationId !== '' && this.model.graduationTime && this.message.nameError === '' && this.message.telphoneError === '' && this.message.emailError === '' && this.message.wechatNumberError === '' && this.message.universityError === '' && this.message.majorError === '') {
                this.step = '2';
        } else {
            this.$notify({
                message: '请填写必填项',
                duration: 2000,
                background: 'rgb(255, 68, 68)',
              });
        }
    }
    // 提交
    private async submit() {
        if (this.model.radioOne === '1') {
            this.model.radioOneId = true;
        } else if (this.model.radioOne === '2') {
            this.model.radioOneId = false;
        }
        if (this.model.radioTwo === '1') {
            this.model.radioTwoId = true;
        } else if (this.model.radioTwo === '2') {
            this.model.radioTwoId = false;
        }
        if (this.model.InforSourceId !== '' && this.model.jobOne !== '' && this.model.jobPlaceCode !== '' && this.model.radioOneId !== '' && this.model.radioTwoId !== '' && this.message.selfEvaluationError === '' && this.model.fileIds.length !== 0) {
            if (this.info.showInfoSorceText) {
                if (this.message.InforSourceTextError !== '' || this.model.InforSourceText === '') {
                    this.$notify({
                        message: '请填写必填项',
                        duration: 2000,
                        background: 'rgb(255, 68, 68)',
                    });
                    return;
                }
            }
            const entity = {
                ID: '',
                unionid: this.user.unionid, // 微信返回的unionid
                ChannelType: this.model.ChannelType,
                Name: this.model.username,
                Sex: this.model.sexId,
                NativePlaceName: this.model.nativePlaceCode,
                FamilyHabitatName: this.model.familyPlaceCode,
                PhoneNumber: this.model.telphone,
                Email: this.model.email,
                Wechat: this.model.wechatNumber,
                SchoolName: this.model.university,
                SchoolMajor: this.model.major,
                GraduationTime: this.model.graduationTime,
                HighestEducationId: this.model.educationId,
                RecruitmentSource: this.model.InforSourceId,
                DetailSources: this.model.InforSourceText,
                RecruitmentjobOne: this.model.jobOne,
                RecruitmentjobTwo: this.model.jobTwo,
                IntentionalWorkplaceName: this.model.jobPlaceCode,
                AdjustJob: this.model.radioOneId,
                AdjustPlace: this.model.radioTwoId,
                selfEvaluation: this.model.selfEvaluation,
                files: this.model.fileIds,
            };
            this.info.isDisabled = true;
            let submitSuccess: any;
            if (this.isEdit) {
                // 修改简历
                entity.ID = this.resumeId;
                submitSuccess = await this.$api.httpPost('WeChatInterface/RecruitmentSchoolWeChat/PostUpdateCampResum', entity);
            } else {
                // 新增简历
                submitSuccess = await this.$api.httpPost('WeChatInterface/RecruitmentSchoolWeChat/Add', entity);
            }
            if (submitSuccess.Success) {
                this.step = '3';
            } else {
                this.info.isDisabled = false;
                this.$dialog.alert({
                    title: '投递失败',
                    message: submitSuccess.AllMessages,
                });
                return;
            }
        } else {
            this.$notify({
                message: '请填写必填项',
                duration: 2000,
                background: 'rgb(255, 68, 68)',
              });
        }
    }

    private findPlace(name: string) {
        let parentPlace = '';
        this.info.optionsList.forEach((option: any) => {
            if (option.children) {
                const target = option.children.find((place: any) => place.value === name);
                if (target) {
                    parentPlace = option.value;
                }
            }
        });
        return parentPlace;
    }
}
